import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import '@mdi/font/css/materialdesignicons.css'
import ro from 'vuetify/es5/locale/ro'
import DatetimePicker from 'vuetify-datetime-picker'

Vue.use(DatetimePicker)

Vue.use(Vuetify);

const opts = {
    lang: {
        locales: {ro},
        current: 'ro'
    }
}

export default new Vuetify(opts)
